// extracted by mini-css-extract-plugin
module.exports = {"form":"form--wDItU","text":"text--vTs9k","line":"line--xVp__"};